export default __webpack_public_path__ + "static/media/wazdan.787dc130.svg";